import { api } from "services/restUtil";

type CreatePurchaseIntentResponse = {
  client_secret: string;
  status: string;
};

type PostPurchaseIntentPayload = {
  idempotency_key: string;
  save_pm?: boolean;
  use_saved_pm?: boolean;
};
export async function postPricingModelItemPurchaseIntent(
  id: string,
  payload: PostPurchaseIntentPayload
): Promise<CreatePurchaseIntentResponse> {
  const url = `/pricing/model/item/${id}/intent/purchase`;
  return api.post(url, payload);
}

type PurchaseSubscriptionPlanPayload = {
  idempotency_key: string;
};
export function purchaseSubscription(payload: PurchaseSubscriptionPlanPayload) {
  return api.post<PurchaseSubscriptionPlanPayload, CreatePurchaseIntentResponse>(
    "/subscription/plan/purchase",
    payload
  );
}

export function generateIdempotencyKey(): string {
  return crypto.randomUUID().split("-").join("");
}
